import { render, staticRenderFns } from "./ProfileTransactionsElement.vue?vue&type=template&id=e001843a&scoped=true"
import script from "./ProfileTransactionsElement.vue?vue&type=script&lang=js"
export * from "./ProfileTransactionsElement.vue?vue&type=script&lang=js"
import style0 from "./ProfileTransactionsElement.vue?vue&type=style&index=0&id=e001843a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e001843a",
  null
  
)

export default component.exports